import './StatusFailureIcon.scss';
import { ReactElement } from 'react';
import { InfoIcon } from '../../../design/static/icons/InfoIcon';

export const StatusFailureIcon = (): ReactElement => <InfoIcon className='status-failure-icon' />;
